import { Select } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import {
    dramaSortDirectionIntlId,
    dramaSortIntlId,
    type DramaListSortDirection,
    type DramaListSortField,
} from '@/pages/drama-review/utils';

type SortFieldSelectProps = {
    value?: DramaListSortField;
    placeholderId: string;
    options: DramaListSortField[];
    onChange: (value?: DramaListSortField) => void;
};

type SortDirectionSelectProps = {
    value: DramaListSortDirection;
    disabled?: boolean;
    options: DramaListSortDirection[];
    onChange: (value: DramaListSortDirection) => void;
};

export const SortFieldSelect: React.FC<SortFieldSelectProps> = ({
    value,
    placeholderId,
    options,
    onChange,
}) => {
    const { formatMessage } = useIntl();

    return (
        <Select
            allowClear
            placeholder={<FormattedMessage id={placeholderId} />}
            style={{ width: 160 }}
            value={value}
            onChange={(next) => onChange(next)}
            options={options.map((sort) => ({
                value: sort,
                label: formatMessage({ id: dramaSortIntlId(sort) }),
            }))}
        />
    );
};

export const SortDirectionSelect: React.FC<SortDirectionSelectProps> = ({
    value,
    disabled,
    options,
    onChange,
}) => {
    const { formatMessage } = useIntl();

    return (
        <Select
            disabled={disabled}
            style={{ width: 100 }}
            value={value}
            onChange={onChange}
            options={options.map((direction) => ({
                value: direction,
                label: formatMessage({ id: dramaSortDirectionIntlId(direction) }),
            }))}
        />
    );
};
